import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/layoutActions";
import { validatieStatussenLoaded } from "../../../actions/validatieStatusActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import * as sessionActions from "../../../actions/sessionActions";
import { throwException } from "../../../actions/exceptionActions";
import OrganisatieForm from "./OrganisatieForm";
import redirector from "../../../util/redirector";
import OrganisatiePageHelper from "./OrganisatiePageHelper";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import { onDropFiles, onRemoveFile } from "../../../components/common/FilesHelperUtil";
import ConfirmModal from "../../../components/common/ConfirmModal";
import { orderByPropertyName } from "../../../util/orderBy.js";
import mergeDeep from "../../../util/mergeDeep";

class OrganisatiePage extends ScrollToFirstErrorComponent {
	constructor(props, context) {
		super(props, context, true);

		this.filesHelper = null;
		this.state = {
			transactieId: '',
			model: {
				naam: null,
				afkorting: null,
				telefoon: null,
				gsm: null,
				email: null,
				website: null,
				extraGegevens: null,
				logo: null,
				documentatie: null,
				niveau: 0,
				type: 0
			},
			originalModel: {
				naam: null,
				afkorting: null,
				telefoon: null,
				gsm: null,
				email: null,
				website: null,
				extraGegevens: null,
				logo: null,
				documentatie: null,
				niveau: 0,
				type: 0
			},
			hasUnsavedChanges: false,
			shouldScrollToFirstError: false,
			validationMessageType: '',
			errors: {},
			activateModalIsOpen: false,
			nameHasFocus: true
		};

		this.pageHelper = new OrganisatiePageHelper(this, redirector);
	}

	componentDidMount = () => {
		this.props.setHasUnsavedChanges(false);
		super.componentDidMount();
		this.pageHelper.init();
	};

	handleOnDropFile = (propertyName, files) => this.handleOnChangeFile(onDropFiles(this.state.model[propertyName] && this.state.model[propertyName].content ? [this.state.model[propertyName]] : [], propertyName, files));
	handleOnRemoveFile = (propertyName, fileName) => this.handleOnChangeFile(onRemoveFile(this.state.model[propertyName] && this.state.model[propertyName].content ? [this.state.model[propertyName]] : [], propertyName, fileName));
	handleOnSave = () => this.pageHelper.save();
	handleOnChange = (event) => this.pageHelper.change(event);
	handleOnChangeFile = (event) => this.pageHelper.changeFile(event);
	handleCloseActivateModal = () => this.pageHelper.closeActivateModal();
	handleActivateSportclub = () => this.pageHelper.activateSportclub();

	render() {
		const state = this.state;
		const model = state.model;
		const { originalModel, activateModalIsOpen } = state;
		const errors = state.errors;
		const disabled = this.props.disabled;

		return (
			<Fragment>
				{activateModalIsOpen && <ConfirmModal
					isOpen={activateModalIsOpen}
					title={'Activeer sportclub'}
					mainText={'Wenst u deze sportclub opnieuw te activeren? De datum van stopzetting zal in dit geval worden leeggemaakt. Hierdoor zal deze sportclub opnieuw zichtbaar worden voor het publiek.'}
					confirmAction={this.handleActivateSportclub}
					cancelAction={this.handleCloseActivateModal}
					confirmText="Ja"
					cancelText="Nee"
				/>}
				<OrganisatieForm
					model={model}
					originalModel={originalModel}
					onDropFile={this.handleOnDropFile}
					onRemoveFile={this.handleOnRemoveFile}
					onChange={this.handleOnChange}
					onChangeFile={this.handleOnChangeFile}
					onSave={this.handleOnSave}
					errors={errors}
					disabled={disabled}
					validationMessageType={this.state.validationMessageType}
					nameHasFocus={state.nameHasFocus}
					userType={this.props.userType}
					organisatieTypes={this.props.organisatieTypes}
					niveaus={this.props.niveaus}
				/>
			</Fragment>);
	}
}

OrganisatiePage.propTypes = {
	loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
	return {
		federatieOndernemingsnummer: state.security.currentOrganisationInfo? state.security.currentOrganisationInfo.ondernemingsnummer: null,
		federatieId: state.security.currentOrganisationInfo? state.security.currentOrganisationInfo.id: null,
		gebruikersnaam: state.security.currentUser,
		disabled: state.session.readOnly,
		transactieId: state.session.activeTransactionId,
		isNew: state.session.isNew,
		searchModel: state.session.sportclubSearchModel,
		activateSportorganisatiePopupAlreadyShown: state.session.activateSportorganisatiePopupShown,
		userType: state.session.userType,
		organisatieTypes: orderByPropertyName(state.referentie.organisatieTypes.map((o) => mergeDeep({}, o)), "naam"),
		niveaus: orderByPropertyName(state.referentie.niveausPerOrganisatie.map((n) => mergeDeep({}, n)), "label")
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadSportOrganisatieOrganisatiePageLayout, dispatch),
		setTabSettings: bindActionCreators(layoutActions.setTabSettings, dispatch),
		validatieStatussenLoaded: bindActionCreators(validatieStatussenLoaded, dispatch),
		ajaxActions: bindActionCreators(ajaxActions, dispatch),
		setActiveSportclub: bindActionCreators(sessionActions.setActiveSportclubId, dispatch),
		setHasUnsavedChanges: bindActionCreators(sessionActions.setHasUnsavedChanges, dispatch),
		throwException: bindActionCreators(throwException, dispatch),
		setActivatiePopupShown: bindActionCreators(sessionActions.setActivatiePopupShown, dispatch),
        setActiveOrganisatieNiveau: bindActionCreators(sessionActions.setActiveOrganisatieNiveau, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganisatiePage);
